import React from 'react';
import { Script, ScriptStrategy } from 'gatsby';
import { isProd } from '@agria/utils';

export const ScriptsBefore = () => (
  <>
    {/* // OneTrust Cookies Consent Notice */}
    <Script
      strategy={ScriptStrategy.postHydrate}
      type="text/javascript"
      src="https://cdn.cookielaw.org/consent/0195d314-c23a-7e66-b11b-7423e7fdb0c3/OtAutoBlock.js"
    />
    <Script
      strategy={ScriptStrategy.postHydrate}
      type="text/javascript"
      data-document-language="true"
      src="https://cdn.cookielaw.org/scripttemplates/otSDKStub.js"
      charSet="UTF-8"
      data-domain-script={`0195d314-c23a-7e66-b11b-7423e7fdb0c3${
        !isProd ? '-test' : ''
      }`}
    />
    <Script
      strategy={ScriptStrategy.postHydrate}
      type="text/javascript"
      dangerouslySetInnerHTML={{ __html: 'function OptanonWrapper() {}' }}
    />
    {/* GTM */}
    <Script strategy={ScriptStrategy.postHydrate}>
      {`
        (function(w,d,s,l,i){
          w[l]=w[l]||[];
          w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
          var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
          j.async=true;
          j.src='https://analytics.agria.ie/gtm.js?id='+i+dl;
          f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','GTM-NWRMBJN');
      `}
    </Script>
    <noscript>
      <iframe
        src="https://analytics.agria.ie/gtm.js?id=GTM-NWRMBJN"
        height="0"
        width="0"
        style={{ display: 'none', visibility: 'hidden' }}
        title="gtm-frame"
      />
    </noscript>
  </>
);
